export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
